import React from "react";
import { UpsellPanelSteps } from "../../../../constants/upsellPanelEnumsAndConstants";
import { useUpsellWidgetContainer } from "../../hooks/useUpsellWidgetContainerContext";
import { useUpsellWidgetModel } from "../../hooks/useUpsellWidgetModelContext";

export const Step6Final = () => {
    const model = useUpsellWidgetModel();
    const { currentStep } = useUpsellWidgetContainer();

    if (currentStep !== UpsellPanelSteps.Step6Final) {
        return null;
    }

    return <div className="step6">
        <div className="row">
            {!model.step6Loader ?
                <div className="col-12 col-xs-12 t-c">
                    <h3> Updating information </h3>
                    <h3>Please wait ...  </h3>
                </div>
                :
                <>
                    <div className="col-12 loading loading-blue text-center">
                        <span>
                            <i className="fa fa-circle-o-notch fa-spin fa-4x fa-fw"></i>
                        </span>
                    </div>
                    <div className="col-12 col-xs-12 t-c">
                        <h3 className="mt-3"> Updating information </h3>
                        <h3>Please wait ...  </h3>
                    </div>
                </>
            }
        </div>
    </div>
};
